import { render, staticRenderFns } from "./Retrabajo.vue?vue&type=template&id=207585d2&"
import script from "./Retrabajo.vue?vue&type=script&lang=js&"
export * from "./Retrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports